@if (errorHandler.lastError(); as msg) {
  <div class="cm-backdrop">
    <div class="cm-modal error">
      <div class="cm-head">
        <span class="cm-eyebrow">Unexpected error</span>
      </div>
      <div class="cm-body">
        <p>Something went wrong. Reload the page if the problem persists.</p>
        <p class="nx-mono text-xs" style="color: var(--nexus-text-dim)">{{ msg }}</p>
      </div>
      <div class="cm-foot">
        <button type="button" class="nx-btn-ghost nx-btn-sm"
                (click)="errorHandler.dismiss()">
          Dismiss
        </button>
        <button type="button" class="nx-btn-ghost nx-btn-sm"
                style="color:var(--nexus-red);border-color:rgba(255,51,102,0.45)"
                (click)="reload()">
          Reload
        </button>
      </div>
    </div>
  </div>
}
